import { gql } from '@apollo/client'

export const GET_VIEWER_PARTNER = gql`
  query getViewerPartner {
    viewer {
      id
      isPartner
    }
  }
`

export default GET_VIEWER_PARTNER
